
FullPage = App.loadClass('core::FullPageHandler')

class exports.BaseDialog extends FullPage

    init: () ->
        @activeReportWidth = null
        @activeReport = null
        @filters = @parent.sidebar
        @appliedFilters = null

        # child classes should call super, set layout URL,
        # set report subhandlers, and then call createDialog()


    initFirstReport: () ->
        active_anchor = $(@dialog).find('ul.nav-tabs li a:visible:first')
        @defaultSub = active_anchor.data('handler-name')
        sub = @createSubHandler(@defaultSub, 'Tab')
        if sub
            sub.init()
            @activeReport = sub

        $(active_anchor).tab('show')


    afterLoadLayout: () ->
        @openDialog()
        ths = this

        @msg = @dialog.find('.message_writer')
        @dialog.find('.declaration-pdf-button').hide()

        #set the active tab to show up
        @initFirstReport()

        @resize()

        # This is important, otherwise the Dialog itself will catch the event as it propagates
        @dialog.find('.nav-tabs').on 'shown', (e) ->
            e.stopPropagation()

        @dialog.find('.nav-tabs a').click (e) ->
            if $(this).parents('li').hasClass 'active'
                return false

            ths.topBuffer = () ->
                undefined

            e.preventDefault()
            ths.destroyAllSubHandlers()

            $(this).tab('show')
            sub = ths.createSubHandler($(this).data('handler-name'), 'Tab')
            if sub
                sub.init()
                ths.activeReport = sub
                if sub.hasPrint? and sub.hasPrint
                    ths.dialog.find('.print-btn').show()
                else
                    ths.dialog.find('.print-btn').hide()


            ths.dialog.css
                top: ths.topBuffer() ? -1

        #apply an event listener to the export to excel buttons
        @dialog.delegate '.excel-link', 'click', (e) =>
            @appliedFilters = @filters.jsonize() unless @appliedFilters?
            url = $(e.currentTarget).data('export-url')
            url = url + '?' + $.param { query: ko.toJSON(@appliedFilters) }
            window.open(url, '_blank')


        @dialog.delegate '.excel-btn', 'click', () =>
            @appliedFilters = @filters.jsonize() unless @appliedFilters?
            url = @activeReport.excelUrl + '?' + $.param { query: ko.toJSON(@appliedFilters) }
            window.open(url, '_blank')


        # events for print button (if there is one)
        @dialog.delegate '.print-btn', 'click', () =>
            ths.activeReport.print()

        writer = @dialog.find('.message_writer')
        writer.message_writer
            autoHide: false

        $(window).unbind('finished_report_load modal_resized').bind 'finished_report_load modal_resized',
            debounce (e) =>
                ths.resize()


    resize: () ->
        ths = this
        ths.dialog.find('.modal-body').resizr()
        element = ths.dialog.find('.tab-content')
        element.resizr({ fudge: -20 })

        if @activeReport?.afterResize?
            @activeReport.afterResize()

    # Called when Apply Filters is clicked
    refreshReport: () ->
        @activeReport?.refreshReport()
        @appliedFilters = @filters.jsonize()
